// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","532":"styles","883":"component---src-pages-404-js"}[chunkId] + "-" + {"230":"aff9e77c9e82d6c5e9bb","532":"02b2cf3585312282950e","883":"14375422642c0d9fbdf1"}[chunkId] + ".js";
};